// import feature discovery default steps and utils
import { PlanningDesktopSteps, createStepsUtil } from '@sdb/planning-ui';

// import utils
import { Trans } from 'react-i18next';

export const DesktopSteps = createStepsUtil(PlanningDesktopSteps, {
  overrides: [
    {
      id: 'start',
      title: <Trans i18nKey="featureDiscovery.start.title" />,
      description: <Trans i18nKey="featureDiscovery.start.description" />
    },
    {
      id: 'navigationRail',
      title: <Trans i18nKey="featureDiscovery.navigationRail.title" />,
      description: (
        <Trans i18nKey="featureDiscovery.navigationRail.description" />
      )
    },
    {
      id: 'appSwitcher',
      title: <Trans i18nKey="featureDiscovery.appSwitcher.title" />,
      description: <Trans i18nKey="featureDiscovery.appSwitcher.description" />
    },
    {
      id: 'breadcrumbs',
      title: <Trans i18nKey="featureDiscovery.breadcrumbs.title" />,
      description: <Trans i18nKey="featureDiscovery.breadcrumbs.description" />
    },
    {
      id: 'profileMenuButton',
      title: <Trans i18nKey="featureDiscovery.profileMenuButton.title" />,
      description: (
        <Trans i18nKey="featureDiscovery.profileMenuButton.description" />
      ),
      offset: {
        x: 35,
        y: -38
      }
    },
    {
      id: 'restartButton',
      title: <Trans i18nKey="featureDiscovery.restartButton.title" />,
      description: (
        <Trans i18nKey="featureDiscovery.restartButton.description" />
      ),
      offset: {
        x: 35,
        y: 25
      }
    }
  ],
  skipIds: ['notifications']
});
